import { useI18n } from '../../../../../context/I18nContext';
import './UnreadMessageMarker.css';

/**
 * A component to display an unread message marker.
 * Shows a static "Unread Messages" separator that persists until the user sends a message or switches rooms.
 * The visibility is controlled by the parent component (Messages.jsx) via the showReadMarker flag.
 */
const UnreadMessageMarker = () => {
  const { t } = useI18n();

  return (
    <div
      className="unread-message-marker"
      id="unread-marker"
      role="separator"
      aria-label={t('Messages.unreadMessages')}
    >
      <div className="unread-marker-line" />
      <span className="unread-marker-label">{t('Messages.unreadMessages')}</span>
      <div className="unread-marker-line" />
    </div>
  );
};

export default UnreadMessageMarker;
